import { render, staticRenderFns } from "./hostel.vue?vue&type=template&id=6c7b532c&"
import script from "./hostel.vue?vue&type=script&lang=ts&"
export * from "./hostel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports